import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Api from '../../../services/Api';

const loadBuildings = async () => {
  const response = await Api.get('instances/building-components');
  if (response.status === 200) {
    return response.data.data.map(component => ({
      label: `${component.name} [${component.code}]`,
      value: component.id,
    }));
  }
  return [];
};

const ComponentsSelector = ({
  onChanged,
  selectedIds,
}) => {
  const [components, setComponents] = useState([]);
  useEffect(() => {
    loadBuildings().then(data => setComponents(data));
  }, []);
  let selectedItems;
  if (selectedIds && selectedIds.length > 0) {
    selectedItems = components.filter(b => selectedIds.includes(b.value));
  }

  return (
    <Select
      key="building-selector-instance"
      options={components}
      value={selectedItems}
      onChange={(value) => {
        if (onChanged) {
          onChanged(value);
        }
      }}
      placeholder="Select Components"
      isMulti
    />
  );
};

ComponentsSelector.propTypes = {
  onChanged: PropTypes.func,
  selectedIds: PropTypes.array,
};

ComponentsSelector.defaultProps = {
  onChanged: undefined,
  selectedIds: undefined,
};

export default ComponentsSelector;
